module.exports = __webpack_public_path__ + "static/media/ic_trash.e9963b33.svg";